import { io } from 'socket.io-client';

const SERVER_URL = typeof window !== 'undefined' ? window.location.origin : (process.env.REACT_APP_SERVER_URL || 'https://wsticket.frozentoasty.de');

let socket = null;
let connecting = false;
let registeredListeners = new Map();
let reconnectCallbacks = [];

function ensureSocket() {
  if (socket && (socket.connected || connecting)) {
    return socket;
  }

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
  }

  connecting = true;

  socket = io(SERVER_URL, {
    transports: ['websocket', 'polling'],
    upgrade: true,
    timeout: 20000,
    forceNew: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    maxHttpBufferSize: 1e8,
    pingTimeout: 60000,
    pingInterval: 25000,
  });

  socket.on('connect', () => {
    console.log('Socket connected:', socket.id);
    connecting = false;
  });

  socket.on('disconnect', (reason) => {
    console.log('Socket disconnected:', reason);
    if (reason === 'io server disconnect') {
      socket.connect();
    }
  });

  socket.on('reconnect', (attemptNumber) => {
    console.log('Socket reconnected after', attemptNumber, 'attempts');
    connecting = false;
    reconnectCallbacks.forEach(cb => {
      try { cb(); } catch (e) { console.error('Reconnect callback error:', e); }
    });
  });

  registeredListeners.forEach((handlers, event) => {
    handlers.forEach(handler => {
      socket.on(event, handler);
    });
  });

  return socket;
}

function on(event, handler) {
  if (!registeredListeners.has(event)) {
    registeredListeners.set(event, new Set());
  }
  registeredListeners.get(event).add(handler);

  const s = ensureSocket();
  if (s) s.on(event, handler);
}

function off(event, handler) {
  if (registeredListeners.has(event)) {
    registeredListeners.get(event).delete(handler);
    if (registeredListeners.get(event).size === 0) {
      registeredListeners.delete(event);
    }
  }
  if (socket) socket.off(event, handler);
}

function onReconnect(callback) {
  reconnectCallbacks.push(callback);
  return () => {
    reconnectCallbacks = reconnectCallbacks.filter(cb => cb !== callback);
  };
}

function disconnect() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  connecting = false;
  registeredListeners.clear();
  reconnectCallbacks = [];
}

function getSocket() {
  return ensureSocket();
}

export { getSocket, on, off, onReconnect, disconnect };
export default { getSocket, on, off, onReconnect, disconnect };
